import { render, staticRenderFns } from "./courseTabList.vue?vue&type=template&id=6a57db97&scoped=true&"
import script from "./courseTabList.vue?vue&type=script&lang=js&"
export * from "./courseTabList.vue?vue&type=script&lang=js&"
import style0 from "./courseTabList.vue?vue&type=style&index=0&id=6a57db97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57db97",
  null
  
)

export default component.exports